export default "__VITE_ASSET__01T_9ybL__"